// src/components/PrivateRoute.jsx
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";

const PrivateRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [hasNickname, setHasNickname] = useState(false);

  useEffect(() => {
    const checkUser = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/auth/me`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setHasNickname(!!res.data.nickname);
      } catch (err) {
        setHasNickname(false);
      }
      setLoading(false);
    };
    checkUser();
  }, []);

  if (loading) return null;
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/" replace />;
  if (!hasNickname) return <Navigate to="/set-nickname" replace />;
  return children;
};

export default PrivateRoute;